export const getBindingIndexFromBindingData = (bindingData) => {

    let bindingValue = bindingData?.value;
    if (bindingValue) {
        // bindingValue format should follow these examples:
        //   {{xd.listing.pictures.1.pictureUrl}}
        //   {{#if xd.user.defaultHeadshot}}{{xd.user.defaultHeadshot}}{{else}}{{xd.user.imageGallery.headshots.0.imageUrl}}{{/if}}
        // looking for first number surrounded by dots - index is 0-based, but provided as string, so it will
        // pass the ternary conditions when used in orderImageLabel below
        return bindingValue.split(".").find(x => !isNaN(x));
    }

    return undefined;

}
